/**
 * @deprecated
 * Slots have been deprecated and will be removed in the next major version
 * Use the `label` prop instead
 */
export var CheckboxSlot;
(function (CheckboxSlot) {
    CheckboxSlot["label"] = "label";
})(CheckboxSlot || (CheckboxSlot = {}));
